import { useContext } from "react";
import UserContext from "../context/user";
import { useState } from "react";
import Header from "../components/header";
import CookieBanner from "../components/cookie-banner";
import AppsLogin from "./apps-login";
import CookiePolicy from "./cookie-policy";
import ForgotPassword from "./forgot-password";
import Footer from "../components/footer";
import BorseBody from "../components/scholarships/borse-body";
import useDocumentTitle from "../hooks/useDocumentTitle";
import useTealiumOnPageLoad from "../utils/tealium";
import CmsPage from "../components/cms-page";
import BorseContext from "../context/borse";
import AppError from "../components/app-error";

const APP = "BORSE_DI_STUDIO";

const BorseDiStudio = () => {
  const { logged } = useContext(UserContext);
  const {
    survey,
    error,
    labels,
    status,
    navigation,
    setNavigation,
    appLang,
    setAppLang,
    languages,
  } = useContext(BorseContext);
  const [forgotPw, setForgotPw] = useState();

  useTealiumOnPageLoad({ pageSection1: "welfare", pageSection2: "Borse di studio" });
  useDocumentTitle("EssilorLuxottica Borse di Studio e Rimborso Spese Universitarie");

  return (
    <>
      {logged ? (
        Object.entries(labels).length === 0 ? (
          <div className="loading-spinner mt" />
        ) : (
          <>
            <Header
              selectedLanguage={appLang}
              setSelectedLanguage={setAppLang}
              languages={languages}
              labels={labels}
              app={APP}
              appTitle={survey?.title}
            />
            <main className="app-content borse-content">
              {["privacy-policy", "cookie-policy"]?.includes(navigation) ? (
                {
                  "privacy-policy": (
                    <CmsPage
                      path="footer/privacy-policy"
                      title={labels?.WELFARE_PRIVACY_POLICY}
                      setNavigation={setNavigation}
                      key={navigation}
                      appLang={appLang}
                    />
                  ),
                  "cookie-policy": (
                    <CookiePolicy logged={true} setNavigation={setNavigation} appLang={appLang} />
                  ),
                }[navigation]
              ) : error ? (
                <AppError error={error} labels={labels} />
              ) : !survey && status !== "invalid-campaign" ? (
                <div className="loading-spinner mt" />
              ) : (
                <BorseBody />
              )}
            </main>
            <Footer setNavigation={setNavigation} app={APP} labels={labels} />
          </>
        )
      ) : forgotPw ? (
        <ForgotPassword setForgotPw={setForgotPw} labels={labels} />
      ) : navigation === "cookie-policy" ? (
        <CookiePolicy logged={false} setNavigation={setNavigation} appLang={appLang} />
      ) : (
        <AppsLogin app={APP} setForgotPw={setForgotPw} labels={labels} />
      )}
      <CookieBanner labels={labels} setNavigation={setNavigation} />
    </>
  );
};

export default BorseDiStudio;
